<template>
  <div class="pago-tarjeta">
    <!-- Paso 1: consultar la tarjeta -->
    <div v-if="!consultada" class="pago-tarjeta__paso">
      <div class="pago-tarjeta__titulo"><v-icon color="primary" class="mr-2">mdi-gift-outline</v-icon>Pagar con tarjeta de regalo</div>
      <p class="pago-tarjeta__ayuda">Escribe o escanea el código de la tarjeta y consulta su saldo. Después eliges cuánto usar.</p>
      <ng-text
        :label="$t('code')"
        rules="required"
        :filled="false"
        hide-details
        :dense="false"
        show-required="true"
        v-model="reference"
        @input="restartBalance()"
        @keyup.native.enter="getBalanceCard()"
        :disabled="orderNoBalance()"
      ></ng-text>
      <v-btn
        block
        large
        depressed
        color="primary"
        class="mt-3 pago-tarjeta__consultar"
        :loading="consultando"
        :disabled="!reference || orderNoBalance()"
        :title="$t('Consultar Saldo')"
        @click="getBalanceCard()"
      >
        <v-icon left>mdi-magnify</v-icon>Consultar saldo
      </v-btn>
    </div>

    <!-- Paso 2: la tarjeta, su saldo y cuánto usar -->
    <div v-else class="pago-tarjeta__paso">
      <div class="pago-tarjeta__tarjeta">
        <div class="pago-tarjeta__tarjeta-cabecera">
          <span><v-icon small color="white" class="mr-1">mdi-gift-outline</v-icon>Tarjeta {{ reference }}</span>
          <v-btn x-small text dark class="pago-tarjeta__otra" @click="otraTarjeta()">Usar otra tarjeta</v-btn>
        </div>
        <div class="pago-tarjeta__saldos">
          <div>
            <span>Saldo disponible</span>
            <strong class="pago-tarjeta__saldo">{{ $filters.currency(positiveBalance, 0) }}</strong>
          </div>
          <div>
            <span>Falta por pagar</span>
            <strong>{{ $filters.currency(order.getBalance(), 0) }}</strong>
          </div>
        </div>
      </div>

      <v-alert v-if="!(positiveBalance > 0)" dense text type="warning" class="mt-3 mb-0">
        Esta tarjeta no tiene saldo disponible.
      </v-alert>

      <template v-else>
        <v-btn
          block
          large
          depressed
          dark
          class="mt-3 pago-tarjeta__usar boton-pago-completo"
          :disabled="orderNoBalance()"
          @click="usarTodo()"
        >
          <v-icon left>mdi-check-circle-outline</v-icon>Usar {{ $filters.currency(montoMaximo, 0) }} de la tarjeta
        </v-btn>

        <div class="text-center mt-2">
          <v-btn small text color="primary" @click="otroMonto = !otroMonto">
            {{ otroMonto ? "Ocultar" : "Usar otro monto" }}
            <v-icon right small>{{ otroMonto ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </div>

        <v-expand-transition>
          <div v-show="otroMonto" class="pago-tarjeta__teclado">
            <v-row dense class="mt-0">
              <v-col v-for="m in montos" :key="m" cols="4">
                <v-btn
                  :small="is_mobile"
                  block
                  elevation="2"
                  :large="!is_mobile"
                  :disabled="orderNoBalance()"
                  @click="addTotalPayment(paymentMethod, m)"
                  :title="$t('add') + ' ' + $filters.currency(m, 0)"
                >{{ $filters.currency(m, 0) }}</v-btn>
              </v-col>
              <v-col cols="4">
                <v-btn :small="is_mobile" block elevation="2" :large="!is_mobile" :title="$t('erase')" @click="cleanTotalPayment(paymentMethod)">
                  <v-icon>mdi-backspace-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <div class="pago-tarjeta__monto">
              <span>{{ $t("amount") }}:</span>
              <strong>{{ $filters.currency(totalPayment, 0) }}</strong>
            </div>
            <v-btn
              block
              large
              depressed
              color="primary"
              :disabled="!positiveBalance || !reference || totalPayment < 1 || order.getBalance() == 0"
              @click="addPayment()"
            >
              <v-icon left>mdi-check-outline</v-icon>Usar {{ $filters.currency(totalPayment, 0) }}
            </v-btn>
          </div>
        </v-expand-transition>
      </template>
    </div>
  </div>
</template>
<script>
const DEFAULT_ITEM = {
  id: "",
  name: "",
  last_name: "",
  email: "",
  identification: "",
  phone: "",
  address: "",
};
export default {
  name: "CartPaymentsKeyboard",
  data: () => ({
    isPayCard: true,
    searched: false,
    totalPayment: 0,
    totalBalanceCard: 0,
    consultada: false,
    consultando: false,
    otroMonto: false,
    montos: [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000, 100000],
    reference: null,
    change: 0,
  }),
  props: {
    paymentMethod: {
      type: Object,
      default: null,
    },
    order: Object,
    is_mobile: Boolean,
  },
  //props: ['customer'],

  mounted() {
    /*if(this.customer){
      setTimeout(() => {


      this.item = JSON.parse(JSON.stringify(this.customer));
      this.searched = true;
      this.key++;
      }, 250)
    }*/
  },
  computed: {
    // Lo más que se puede cobrar con esta tarjeta ahora: su saldo, sin pasar de lo que falta por pagar.
    montoMaximo() {
      return Math.min(parseInt(this.positiveBalance), parseInt(this.order.getBalance()));
    },
    positiveBalance() {
      let payments = this.order.getPayments();
      let totalBalance = this.totalBalanceCard;
      for (const payment of payments) {
        if (payment.reference == this.reference) {
          totalBalance -= payment.value;
        }
      }
      return totalBalance > 0 ? totalBalance : 0;
    },
  },
  methods: {
    addTotalPayment(paymentMethod, value) {
      this.totalPayment += value;
      if (this.positiveBalance < this.totalPayment) {
        this.totalPayment = parseInt(this.positiveBalance);
      }
      if (paymentMethod.manage_change) {
        this.calculateChange();
      }
    },
    restartBalance() {
      this.totalBalanceCard = 0;
      this.consultada = false;
      this.totalPayment = 0;
    },
    otraTarjeta() {
      this.reference = null;
      this.otroMonto = false;
      this.restartBalance();
    },
    // «Usar todo»: el saldo de la tarjeta o lo que falte por pagar, lo que sea menor.
    usarTodo() {
      this.payComplete();
      this.addPayment();
    },
    async addPayment() {
      // Sin saldo o sin monto no hay pago: un clic repetido no debe dejar pagos de $0 en el pedido.
      if (!(this.order.getBalance() > 0) || !(this.totalPayment > 0)) {
        this.totalPayment = 0;
        return;
      }
      let value = this.totalPayment;
      if (this.totalPayment > this.order.getBalance()) {
        value = this.order.getBalance();
      }
      let turn = this.$store.getters.turn;
      this.$pos.addPayment(this.order, {
        _id: new Date().getTime(),
        payment_method: this.paymentMethod,
        date: this.$filters.datetime(new Date()),
        value: value,
        acc_income_id: null,
        reference: this.reference,
        bill_cash_register_id: this.order.getBillCashRegisterId(),
        bill_cash_register_turn_id: turn.id,
        change: this.change,
      });
      this.totalPayment = 0;
    },
    async getBalanceCard() {
      if (!this.reference || this.consultando) {
        return;
      }
      this.consultando = true;
      let res = null;
      try {
        res = await this.$http.post(
          "api/v1/gift-card/get-balance",
          { code: this.reference },
          true,
          true
        );
      } catch (e) {
        // Sin red el aviso general ya salió; el botón queda libre para volver a consultar (antes se quedaba girando).
        return;
      } finally {
        this.consultando = false;
      }
      if (res && res.success) {
        this.totalBalanceCard = res.balance;
        this.consultada = true;
        this.otroMonto = false;
      }
    },
    calculateChange() {
      const change = this.totalPayment - this.order.getBalance();
      if (change < 0) {
        this.change = 0;
      } else {
        this.change = change;
      }
    },
    cleanTotalPayment(paymentMethod) {
      this.totalPayment = 0;
      if (paymentMethod.manage_change) {
        this.calculateChange();
      }
    },
    payComplete() {
      let balanceOrder = this.order.getBalance();
      if (this.positiveBalance > balanceOrder) {
        this.totalPayment = balanceOrder;
      } else {
        this.totalPayment = parseInt(this.positiveBalance);
      }
    },
    cancel() {
      this.clear();
      this.searched = false;
      this.key++;
      this.$emit("cancel");
    },
    orderNoBalance() {
      if (this.order.getBalance() == 0) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.pago-tarjeta {
  padding: 4px 8px 8px;
}
.pago-tarjeta__titulo {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: var(--pos-azul-marino);
}
.pago-tarjeta__ayuda {
  margin: 6px 0 14px;
  color: #5f6368;
}
.pago-tarjeta__tarjeta {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.pago-tarjeta__tarjeta-cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  background: var(--pos-encabezado);
  color: #fff;
  font-family: "Courier New", monospace;
  letter-spacing: 1px;
}
.pago-tarjeta__saldos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 12px 14px;
}
.pago-tarjeta__saldos > div {
  display: flex;
  flex-direction: column;
}
.pago-tarjeta__saldos span {
  font-size: 12px;
  color: #5f6368;
}
.pago-tarjeta__saldos strong {
  font-size: 20px;
  color: var(--pos-azul-marino);
}
.pago-tarjeta__saldos .pago-tarjeta__saldo {
  font-size: 26px;
  color: #1b5e20;
}
.pago-tarjeta__usar {
  letter-spacing: 0;
  font-weight: 700;
}
.pago-tarjeta__teclado {
  margin-top: 8px;
}
.pago-tarjeta__monto {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0;
  padding: 10px 14px;
  border-radius: 8px;
  background: #f5f6f8;
  font-size: 18px;
}
/* Pantalla baja (POS táctil 1024x768): teclas más bajas para que quepa el monto y el botón de usar */
@media (max-height: 800px) {
  .pago-tarjeta__teclado .v-btn {
    height: 40px !important;
  }
  .pago-tarjeta__monto {
    margin: 4px 0;
    padding: 6px 14px;
  }
}
</style>
